<template>
  <div>
    <el-select v-model="tipo" default-first-option="" class="el-select-filter" placeholder="Select" @change="changeFilters" >
      <el-option
        v-for="item in tipos"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: 'Filtros',
  data () {
    return {
      tipo: '',
      tipos: [
        {
          label: 'Todos',
          value: ''
        },
        {
          label: 'Descredenciados',
          value: 'descredenciados'
        },
        {
          label: 'Substituidos',
          value: 'substituidos'
        }
      ]
    }
  },
  methods: {
    changeFilters () {
      this.$emit('change', {
        tipo: this.tipo
      })
    }
  }
}
</script>
<style scoped>

</style>
